// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:15
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class CommArgs_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.CommArgs';
  $t: string = 'SagaBase.Defines.CommArgs';

  public static GetMembers(): string[] {
    return ['SiteId', 'Message', 'TextMessage', 'UserId', 'UserName', 'StampType', 'ParentUId', 'Targets', 'ComRequestUid'];
  }

  public GetMembers(): string[] {
    return CommArgs_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public SiteId: number = 0;
  public Message: string;
  public TextMessage: any;
  public UserId: number = 0;
  public UserName: string;
  public StampType: number = 0;
  public ParentUId: Guid = GuidTools.Empty;
  public Targets: any[];
  public ComRequestUid: Guid = GuidTools.Empty;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
